module.exports = __webpack_public_path__ + "img/dwe_diggerstoken.f52ebac.png";